define("shared/components/shared/post/secondary/hashtag-suggestions/mobile-upgrade", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cMH--upgradeCard">
    <div class="cMH--upgradeCard__input">
      <div class="u--block">
        <p class="u--text--bold u--m__b__0 qa--autoHashtagOption">
          {{t "hashtag_suggestions.limited.upgrade_modal_free.auto_button.header"}}
        </p>
        <p class="u--m__b__0">{{t "hashtag_suggestions.limited.upgrade_modal_free.auto_button.detail"}}</p>
      </div>
    </div>
    <hr />
    <p>
      {{t "shared_phrases.available_on_the"}}
      <Shared::Ui::Button @onClick={{fn this.openFeatureModal "growth"}} @variant="unstyled" class="u--p__0">
        <span class="u--text--bold cMH--upgradeCardPlan--growth">
          {{t "plans.append_plan" plan=(t "plans.plan_names.growth")}}
        </span>
        {{svg-jar "info" class="o--icon o--icon--hl"}}
      </Shared::Ui::Button>
    </p>
  </div>
  
  <div class="cMH--upgradeCard">
    <div class="cMH--upgradeCard__input">
      <div class="u--block">
        <p class="u--text--bold u--m__b__0 qa--searchHashtagOption">
          {{t "hashtag_suggestions.limited.upgrade_modal_free.search_button.header"}}
        </p>
        <p class="u--m__b__0">{{t "hashtag_suggestions.limited.upgrade_modal_free.search_button.detail"}}</p>
      </div>
    </div>
    <hr />
    <p>
      {{t "shared_phrases.available_on_the"}}
      <Shared::Ui::Button @onClick={{fn this.openFeatureModal "growth"}} @variant="unstyled" class="u--p__0">
        <span class="u--text--bold cMH--upgradeCardPlan--growth">{{t "plans.plan_names.growth"}}</span>
      </Shared::Ui::Button>
      {{t "shared_words.and"}}
      <Shared::Ui::Button @onClick={{fn this.openFeatureModal "starter"}} @variant="unstyled" class="u--p__0">
        <span class="u--text--bold cMH--upgradeCardPlan--starter">
          {{t "plans.append_plan" plan=(t "plans.plan_names.starter")}}
        </span>
        {{svg-jar "info" class="o--icon o--icon--yellow {"}}
      </Shared::Ui::Button>
    </p>
  </div>
  
  <div class="cIC--card u--m__lr__lg">
    <div class="cIC--cardHeader">
      <p class="cIC--cardHeader__title">
        {{t "plans.mobile.icon"}}
        {{t "plans.mobile.upgrade_on" platform=this.signupPlatform}}
      </p>
    </div>
    <div class="cIC--cardBody">
      <p class="u--m__b__0">
        {{#if this.isEligibleForTrial}}
          {{t "plans.mobile.upgrade.hashtag_suggestions_trial" platform=this.signupPlatform}}
        {{else}}
          {{t "plans.mobile.upgrade.hashtag_suggestions" platform=this.signupPlatform}}
        {{/if}}
        <Shared::Ui::Button
          @class="u--p__0 u--text--hl"
          @text={{t "shared_phrases.learn_more"}}
          @variant="unstyled"
          onClick={{this.openMobileRedirectModal}}
        />
      </p>
    </div>
  </div>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Upgrade::AllFeaturesModal
        @close={{toggle-action "showAllFeaturesModal" this}}
        @isMonthly={{false}}
        @plan={{this.plan}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "YGRhhBWp",
    "block": "[[[10,0],[14,0,\"cMH--upgradeCard\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold u--m__b__0 qa--autoHashtagOption\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"hashtag_suggestions.limited.upgrade_modal_free.auto_button.header\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,0],[\"hashtag_suggestions.limited.upgrade_modal_free.auto_button.detail\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[12],[13],[1,\"\\n  \"],[10,2],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"shared_phrases.available_on_the\"],null]],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--p__0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,2],[[30,0,[\"openFeatureModal\"]],\"growth\"],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold cMH--upgradeCardPlan--growth\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.append_plan\"],[[\"plan\"],[[28,[37,0],[\"plans.plan_names.growth\"],null]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon o--icon--hl\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"cMH--upgradeCard\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold u--m__b__0 qa--searchHashtagOption\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"hashtag_suggestions.limited.upgrade_modal_free.search_button.header\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,0],[\"hashtag_suggestions.limited.upgrade_modal_free.search_button.detail\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[12],[13],[1,\"\\n  \"],[10,2],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"shared_phrases.available_on_the\"],null]],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--p__0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,2],[[30,0,[\"openFeatureModal\"]],\"growth\"],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold cMH--upgradeCardPlan--growth\"],[12],[1,[28,[35,0],[\"plans.plan_names.growth\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[1,[28,[35,0],[\"shared_words.and\"],null]],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--p__0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,2],[[30,0,[\"openFeatureModal\"]],\"starter\"],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold cMH--upgradeCardPlan--starter\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.append_plan\"],[[\"plan\"],[[28,[37,0],[\"plans.plan_names.starter\"],null]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon o--icon--yellow {\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"cIC--card u--m__lr__lg\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"plans.mobile.icon\"],null]],[1,\"\\n      \"],[1,[28,[35,0],[\"plans.mobile.upgrade_on\"],[[\"platform\"],[[30,0,[\"signupPlatform\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardBody\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n\"],[41,[30,0,[\"isEligibleForTrial\"]],[[[1,\"        \"],[1,[28,[35,0],[\"plans.mobile.upgrade.hashtag_suggestions_trial\"],[[\"platform\"],[[30,0,[\"signupPlatform\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,0],[\"plans.mobile.upgrade.hashtag_suggestions\"],[[\"platform\"],[[30,0,[\"signupPlatform\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[8,[39,1],[[16,\"onClick\",[30,0,[\"openMobileRedirectModal\"]]]],[[\"@class\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[28,[37,0],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,5],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,6],null,[[\"@close\",\"@isMonthly\",\"@plan\"],[[28,[37,7],[\"showAllFeaturesModal\",[30,0]],null],false,[30,0,[\"plan\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[],false,[\"t\",\"shared/ui/button\",\"fn\",\"svg-jar\",\"if\",\"shared/portal\",\"shared/upgrade/all-features-modal\",\"toggle-action\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/mobile-upgrade.hbs",
    "isStrictMode": false
  });
  let MobileUpgradeComponent = _exports.default = (_class = class MobileUpgradeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "plans", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor3, this);
      _initializerDefineProperty(this, "selectedPlan", _descriptor4, this);
    }
    get isEligibleForTrial() {
      return this.subscriptions.isEligibleForTrial;
    }
    get plan() {
      return this.plans.plans.find(plan => plan.planType === this.selectedPlan);
    }
    get signupPlatform() {
      return this.subscriptions.platform;
    }
    openFeatureModal(plan) {
      this.selectedPlan = plan;
      this.showAllFeaturesModal = true;
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'starter';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openFeatureModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openFeatureModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobileUpgradeComponent);
});